import {
  TranscriptContextActions,
  TranscriptContextActionsMap,
  TranscriptContextTypes,
} from './types';

/**
 * Set action for updateChat
 * @param {{type: TranscriptContextTypes, payload: TranscriptContextActionsMap[TranscriptContextTypes.UPDATE_MESSAGES]}} data
 */
export const updateChat = (
  data: TranscriptContextActionsMap[TranscriptContextTypes.UPDATE_MESSAGES],
): TranscriptContextActions => {
  return {
    type: TranscriptContextTypes.UPDATE_MESSAGES,
    payload: data,
  };
};

/**
 * Set action for startChat
 * @param {{type: TranscriptContextTypes, payload: TranscriptContextActionsMap[TranscriptContextTypes.START_CHAT]}} data
 */
export const startChat = (): TranscriptContextActions => {
  return {
    type: TranscriptContextTypes.START_CHAT,
    payload: null,
  };
};

/**
 * Set action for loadSession
 * @param {{type: TranscriptContextTypes, payload: TranscriptContextActionsMap[TranscriptContextTypes.LOAD_SESSION]}} data
 */
export const loadSession = (
  data: TranscriptContextActionsMap[TranscriptContextTypes.LOAD_SESSION],
): TranscriptContextActions => {
  return {
    type: TranscriptContextTypes.LOAD_SESSION,
    payload: data,
  };
};

/**
 * Set action for startChat
 * @param {{type: TranscriptContextTypes, payload: TranscriptContextActionsMap[TranscriptContextTypes.RESET_CHAT]}} data
 */
export const resetChat = (
  data: TranscriptContextActionsMap[TranscriptContextTypes.RESET_CHAT],
): TranscriptContextActions => {
  return {
    type: TranscriptContextTypes.RESET_CHAT,
    payload: data,
  };
};

/**
 * Set action for startChatFail
 */
export const startChatFail = (): TranscriptContextActions => {
  return {
    type: TranscriptContextTypes.START_CHAT_FAIL,
    payload: '',
  };
};

/**
 * Set action for sendUserMessage
 * @param {{type: TranscriptContextTypes, payload: TranscriptContextActionsMap[TranscriptContextTypes.SEND_MESSAGE]}} data
 */
export const sendUserMessage = (
  data: TranscriptContextActionsMap[TranscriptContextTypes.SEND_MESSAGE],
): TranscriptContextActions => {
  return {
    type: TranscriptContextTypes.SEND_MESSAGE,
    payload: data,
  };
};

/**
 * Set action for sendMessageSuccess
 * @param {{type: TranscriptContextTypes, payload: TranscriptContextActionsMap[TranscriptContextTypes.SEND_MESSAGE_FAIL]}} data
 */
export const sendMessageFail = (
  data: TranscriptContextActionsMap[TranscriptContextTypes.SEND_MESSAGE_FAIL],
): TranscriptContextActions => {
  return {
    type: TranscriptContextTypes.SEND_MESSAGE_FAIL,
    payload: data,
  };
};

/**
 * Set action for sendMessageSuccess
 * @param {{type: TranscriptContextTypes, payload: TranscriptContextActionsMap[TranscriptContextTypes.RESEND_MESSAGE]}} data
 */
export const resendUserMessage = (
  data: TranscriptContextActionsMap[TranscriptContextTypes.RESEND_MESSAGE],
): TranscriptContextActions => {
  return {
    type: TranscriptContextTypes.RESEND_MESSAGE,
    payload: data,
  };
};

/**
 * Set action for messageReactionLocal
 * @param {{type: TranscriptContextTypes, payload: TranscriptContextActionsMap[TranscriptContextTypes.REACT_MESSAGE_LOCAL]}} data
 */
export const messageReactionLocal = (
  data: TranscriptContextActionsMap[TranscriptContextTypes.REACT_MESSAGE_LOCAL],
): TranscriptContextActions => {
  return {
    type: TranscriptContextTypes.REACT_MESSAGE_LOCAL,
    payload: data,
  };
};

/**
 * Set action for messageReactionFail
 * @param {{type: TranscriptContextTypes, payload: TranscriptContextActionsMap[TranscriptContextTypes.REACT_MESSAGE_FAIL]}} data
 */
export const messageReactionFail = (
  data: TranscriptContextActionsMap[TranscriptContextTypes.REACT_MESSAGE_FAIL],
): TranscriptContextActions => {
  return {
    type: TranscriptContextTypes.REACT_MESSAGE_FAIL,
    payload: data,
  };
};

/**
 * Set action for messageReactionSuccess
 * @param {{type: TranscriptContextTypes, payload: TranscriptContextActionsMap[TranscriptContextTypes.REACT_MESSAGE_SUCCESS]}} data
 */
export const messageReactionSuccess = (
  data: TranscriptContextActionsMap[TranscriptContextTypes.REACT_MESSAGE_SUCCESS],
): TranscriptContextActions => {
  return {
    type: TranscriptContextTypes.REACT_MESSAGE_SUCCESS,
    payload: data,
  };
};

/**
 * Set action for toggleSources
 * @param {{type: TranscriptContextTypes, payload: TranscriptContextActionsMap[TranscriptContextTypes.TOGGLE_SOURCES]}} data
 */
export const toggleSources = (
  data: TranscriptContextActionsMap[TranscriptContextTypes.TOGGLE_SOURCES],
): TranscriptContextActions => {
  return {
    type: TranscriptContextTypes.TOGGLE_SOURCES,
    payload: data,
  };
};